import { ReactNode, useState } from 'react';
import { clickableRow } from './Overview.css';

type RowProps = {
  expanded: boolean;
};

type DescriptionProps = {
  expanded: boolean;
};

export type WithDescriptionProps = {
  row: (props: RowProps) => ReactNode;
  description: (props: DescriptionProps) => ReactNode;
};

export function WithDescription({ row, description }: WithDescriptionProps) {
  const [expanded, setExpanded] = useState(false);
  const toggle = () => setExpanded((value) => !value);
  return (
    <>
      <div
        className={clickableRow}
        role="button"
        tabIndex={0}
        aria-expanded={expanded}
        onClick={() => {
          // A drag to copy a value fires a click on the row; don't toggle then.
          if (window.getSelection()?.toString()) return;
          toggle();
        }}
        onKeyDown={(event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            toggle();
          }
        }}
      >
        {row({ expanded })}
      </div>
      {expanded && description({ expanded })}
    </>
  );
}
